<template>
<div id="app">
  <xmain :title="title" :url="url" :menu="menu" :tools="tools"></xmain>
</div>
</template>

<script>
import Xmain from './xelement/main.vue'
import { api } from './config.js'

export default {
  name: 'app',
  data() {
    return {
      title: '超级服务生',
      url: {
        login: api.account.storeLogin,
        verify: api.account.storeVerify,
        logout: api.account.logout,
        userData: api.account.getUserData
      },
      menu: [
        {
          icon: 'document',
          title: '委托平台下单',
          index: '/order/before'
        },
        {
          icon: 'document',
          title: '上一版本订单',
          index: '/order/old'
        },
        {
          icon: 'document',
          title: '订单管理',
          index: '/order/all'
        },
        {
          icon: 'star-on',
          title: '充值',
          index: '/recharge'
        },
        {
          icon: 'date',
          title: '交易记录',
          index: '/log/money'
        },
        {
          icon: 'x-lock',
          title: '账户安全',
          index: '/sys/safe'
        }
      ],
      tools: [
        {
          title: '消息',
          icon: 'message',
          path: '/sys/message'
        }
      ]
    }
  },
  components:{
    Xmain
  }
}
</script>



// WEBPACK FOOTER //
// StoreApp.vue?b45bb47e